import elementComputed from './computeds/element'
import store from '@/store/index'

export default {
    computed: {
        userInfo(){
            return store.state.userInfo
        },
        ...elementComputed
    },
}